import { MenuItem } from '@mui/material'
import { Field } from 'formik'
import React from 'react'
import { CustomTextField } from 'src/form'

const OCCUPATION_SELECTIONS = [
  { label: 'Working', value: 'WORKING' },
  { label: 'Unemployed', value: 'UNEMPLOYED' },
  { label: 'Disabled', value: 'DISABLED' },
  { label: 'Retired', value: 'RETIRED' },
  { label: 'Student', value: 'STUDENT' },
  { label: 'Stay at home parent', value: 'STAY_AT_HOME_PARENT' },
]

const OCCUPATION_FIELD_NAME = 'patient.occupation'

export const OccupationField = () => (
  <Field component={CustomTextField} fullWidth label="Occupation" name={OCCUPATION_FIELD_NAME} type="select">
    {OCCUPATION_SELECTIONS.map(({ value, label }) => (
      <MenuItem key={value} value={value}>
        {label}
      </MenuItem>
    ))}
  </Field>
)
